import React from 'react';
import { createRoot } from 'react-dom/client';
import ContactForm from '../components/forms/ContactForm';
import NewsletterForm from '../components/forms/NewsletterForm';

// Map of form slugs to their respective components
const formMap = {
    newsletter: NewsletterForm,
    contact: ContactForm
};

// Find all elements with the class 'sar61-form'
const els = document.querySelectorAll('.sar61-form');

// Iterate over each found element and render the appropriate form
els.forEach(el => {
    // Extract data attributes
    const slug = el.dataset.form;
    const title = el.dataset.title;
    const titleSize = el.dataset.titlesize;
    const buttonText = el.dataset.buttonText;

    // Get the form component
    const FormComponent = formMap[slug];

    // Prepare mount point
    const mount = document.createElement('div');
    el.appendChild(mount);

    // Create a React root
    const root = createRoot(mount);

    // Render the form, passing props if available
    if (FormComponent) {
        root.render(<FormComponent title={title} titleSize={titleSize} buttonText={buttonText} />);
    } else {
        root.render(<div>Unknown form: {slug}</div>);
    }
});
